/** Settings: misma tarjeta que habitación + checkbox de selección (paridad Shelly/Samsung). */

import React from 'react';
import { Box, Checkbox } from '@mui/material';
import { AndroidTvDevice } from '../../services/androidtvApi';
import AndroidTvDeviceCard from './AndroidTvDeviceCard';

interface Props {
  device: AndroidTvDevice;
  isSelected: boolean;
  editMode: boolean;
  isRoomEditing?: boolean;
  isEditingName?: boolean;
  dragHandleProps?: Record<string, unknown>;
  onSelect?: (id: number) => void;
  onClick?: (device: AndroidTvDevice) => void;
  onUpdated?: (device: AndroidTvDevice) => void;
  onStartEditName?: () => void;
  onSaveEditName?: (newName: string) => void;
  onCancelEditName?: () => void;
}

const AndroidTvDeviceCardSettings: React.FC<Props> = ({
  device,
  isSelected,
  editMode,
  isRoomEditing = false,
  isEditingName = false,
  dragHandleProps,
  onSelect,
  onClick,
  onUpdated,
  onStartEditName,
  onSaveEditName,
  onCancelEditName,
}) => (
  <Box sx={{
    position: 'relative',
    border: isSelected ? '1px solid #2391FF' : 'none',
    borderRadius: 2,
    overflow: 'visible',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  }}>
    <AndroidTvDeviceCard
      device={device}
      onOpenModal={editMode || isRoomEditing || isEditingName ? undefined : onClick}
      onUpdated={onUpdated}
      interactionLocked={isRoomEditing || isEditingName}
      editMode={editMode}
      isRoomEditing={isRoomEditing}
      isEditingName={isEditingName}
      dragHandleProps={dragHandleProps}
      onStartEditName={onStartEditName}
      onSaveEditName={onSaveEditName}
      onCancelEditName={onCancelEditName}
      showBrandChip={editMode}
    />

    {editMode && onSelect && !isRoomEditing && (
      <Checkbox
        checked={isSelected}
        onChange={(e) => {
          e.stopPropagation();
          onSelect(device.id);
        }}
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: 'absolute',
          bottom: '-5px',
          right: '-5px',
          color: 'red',
          zIndex: 6,
          '& .MuiSvgIcon-root': { color: 'red' },
        }}
      />
    )}
  </Box>
);

export default AndroidTvDeviceCardSettings;
